/* Brand-driven "You might also like".
 *
 * Shopify's own /recommendations endpoint is unusable on this catalogue: `vendor` is the
 * trading entity on all 368 products and `product_type` is empty on all of them, so the
 * engine has no brand or type facet and matches on description prose instead (measured:
 * 13% same-brand). It also returns nothing at all for sold products, which is 86% of the
 * catalogue.
 *
 * So instead we ask Shopify for the product's own brand collection, filtered to in-stock,
 * through the Section Rendering API - `filter.v.availability=1` is applied server-side,
 * BEFORE Liquid's ~50-product cap, which is what makes this correct where a Liquid
 * `where: available` filter silently truncates (Omega: 18 in stock, only 4 in the first 50).
 *
 * Falls back to a general in-stock collection when the product has no brand metafield
 * (Bell & Ross, Mido and MB&F have none) or when the brand alone cannot fill the row.
 */
(function () {
  if (window.__wtPcBrand) return;
  window.__wtPcBrand = true;

  var CARD_SEL = '[data-wt-card]';

  function handleOf(card) {
    // the card <li> carries data-product-handle; the href is only a fallback
    var h = card.getAttribute && card.getAttribute('data-product-handle');
    if (h) return h;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    return a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
  }

  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return { inner: null, cards: [] };
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.wt-pc__inner');
        var track = doc.querySelector('.wt-pc__track');
        // data-wt-card sits ON the <li>, not on a descendant - matches(), not querySelector()
        var cards = track ? Array.prototype.filter.call(track.children, function (li) {
          return li.matches && li.matches(CARD_SEL);
        }) : [];
        return { inner: inner, cards: cards };
      })
      .catch(function () { return { inner: null, cards: [] }; });
  }

  function load(el) {
    if (el.dataset.ready) return;          // the guard belongs on the element, not the script
    el.dataset.ready = '1';

    var limit = parseInt(el.dataset.limit, 10) || 6;
    var exclude = el.dataset.exclude || '';
    var brandUrl = el.dataset.url || '';
    var fallbackUrl = el.dataset.fallbackUrl || '';

    var first = brandUrl ? fetchCards(brandUrl) : Promise.resolve({ inner: null, cards: [] });

    first.then(function (res) {
      var seen = {};
      var picked = [];
      function take(cards) {
        cards.forEach(function (li) {
          if (picked.length >= limit) return;
          var h = handleOf(li);
          if (!h || h === exclude || seen[h]) return;   // positive identity test, never "not a decoration"
          seen[h] = 1;
          picked.push(li);
        });
      }
      take(res.cards);
      var shell = res.inner;

      if (picked.length >= limit || !fallbackUrl) return { shell: shell, picked: picked };
      return fetchCards(fallbackUrl).then(function (fb) {
        take(fb.cards);
        return { shell: shell || fb.inner, picked: picked };
      });
    }).then(function (out) {
      if (!out || !out.shell || !out.picked.length) return;   // nothing to show: stay hidden
      var track = out.shell.querySelector('.wt-pc__track');
      if (!track) return;
      while (track.firstChild) track.removeChild(track.firstChild);
      out.picked.forEach(function (li) { track.appendChild(li); });
      el.innerHTML = '';
      el.appendChild(out.shell);
      if (typeof window.wtHydrateWishlist === 'function') window.wtHydrateWishlist();
      el.dispatchEvent(new CustomEvent('wt-pc:loaded', { bubbles: true }));
    });
  }

  function arm(el) {
    if (!('IntersectionObserver' in window)) { load(el); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        load(e.target);
      });
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(el);
  }

  function init() {
    document.querySelectorAll('wt-brand-recs').forEach(arm);   // NodeList: forEach only
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();
